<template>
  <div class="flex flex-col min-h-screen items-center justify-center" style="background-color: #000">
    <div class="p-7 flex justify-center items-center">
      <a href="/">
        <img src="/images/logo_testo.png" alt="Street Stock Logo" />
      </a>
    </div>
    
    <div class="pb-7 flex flex-col justify-center items-center text-white">
      <h1 class="text-2xl font-bold mb-4">SCARICA LA NOSTRA APP</h1>
      <div class="flex space-x-4 mb-6">
        <a href="https://apps.apple.com/it/app/street-stock/id6739734823" target="_blank">
          <img src="/images/apple.svg" alt="Scarica su App Store" class="h-12" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.streetstock.streetstock&hl=it&pli=1" target="_blank">
          <img src="/images/google.svg" alt="Scarica su Google Play" class="h-12" />
        </a>
      </div>
      
      <!-- <h2 class="text-xl font-semibold mb-2">OPPURE</h2>
      <h3 class="text-lg mb-4">REGISTRATI</h3> -->
    </div>
    
    <!-- <div class="pb-7 flex justify-center items-center">
      <div class="flex justify-center items-center bg-white rounded-md shadow overflow-hidden mx-5 max-w-2xl">
        <form @submit.prevent="store">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-full" label="Cognome" />
            <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-full" label="Nome" />
            <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-8 w-full lg:w-full" label="Città" />
            <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-full" label="Email" />
            <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-full" label="Cellulare" />

            <select-input v-model="form.source" :error="form.errors.source" class="pr-6 pb-8 w-full lg:w-1/2" label="Come hai conosciuto StreetStock?">
              <option value="social">Social</option>
              <option value="passaparola">Passaparola</option>
              <option value="di passaggio">Di passaggio</option>
              <option value="volantino">Volantino</option>
            </select-input>
            
            <div class="pr-6 pb-8 w-full lg:w-full">
              <input class="mr-1" type="checkbox" name="checkbox" id="checkbox" v-model="form.checkbox" /> 
              Ho letto e accetto i 
              <a class="ml-1 text-blue-500" href="termini-condizioni">termini e condizioni</a> e la 
              <a class="ml-1 text-blue-500" href="privacy-policy">privacy policy</a>
              <div class="form-error" v-if="form.errors.checkbox">{{ form.errors.checkbox }}</div>
            </div>
          </div>
          <div class="mt-6 px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
            <loading-button :loading="form.processing" class="btn-indigo" type="submit">Invia</loading-button>
          </div>
        </form>
      </div>
    </div> -->
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Street Stock' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: null,
        last_name: null,
        city: null,
        email: null,
        phone: null,
        checkbox: null,
        source: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('home.store'))
    },
  },
}
</script>